export interface State {
  /**
   * The input element that we are editing
   *
   * __NOTE:__ must be callback to avoid NgRx freezing the object
   */
  editor?: () => HTMLInputElement | HTMLTextAreaElement
  changesInFocusSinceEditorWasActive: number
  enhancementTypeStandardOptions: readonly string[]
  /**
   * Determines which options to show
   *
   * - `all`: show all options
   * - `custom`: show only the custom option
   * - `number`: show only the number of options specified by the number (always includes the custom)
   */
  enhancementTypeCurrentOptionsSelector?: 'all' | 'custom' | number
  enhancement?: string
  enhancementIsLoading: boolean
  enhancementError?: Error
}
export namespace State {
  export const INITIAL: State = {
    changesInFocusSinceEditorWasActive: 0,
    enhancementIsLoading: false,
    enhancementTypeStandardOptions: ['Clearer', 'Shorter', 'Longer'],
  }

  export const ENHANCEMENT_TYPE_CUSTOM_OPTION = 'Other'
}
